import { createReducer } from 'redux-create-reducer';
import camelcaseKeysDeep from 'camelcase-keys-deep';

import { buildHydrateEvent, HYDRATE_DUMMY } from '@AIZ-GL/hydrate-dummy';

import {
  CUSTOMER_DETAILS_FETCHED,
  DEVICES_FETCHED,
  DEVICES_FETCHED_ERROR,
  DEVICES_FETCHING,
} from '../actions/';

const initialState = {
  devicesById: { make: '' },
  devicesLoading: false,
  deviceTypes: [],
};

const dummyData = {
  devicesById: {
    '1234': {
      brandName: 'Apple',
      colors: [],
      deviceImages: [],
      id: '1234',
      make: 'phone',
      models: ['iPhone8,2', 'A1687', 'A1634'],
      name: 'iPhone 6S Plus',
      supported: true,
    },
  },
};

const mapIncomingDevices = devices => {
  return devices.reduce((deviceMap, device) => {
    device = camelcaseKeysDeep(device);
    const defaultImage = device.deviceImages.find(
      image => image.color.id === 'default'
    );

    device.colors.forEach(color => {
      const { id } = color;
      const deviceImage = device.deviceImages.find(
        image => image.color.id === id
      );
      color.url =
        (deviceImage && deviceImage.url) || (defaultImage && defaultImage.url);
    });

    device.defaultImage = defaultImage;
    deviceMap[device.id] = device;

    return deviceMap;
  }, {});
};

const mapIncomingDeviceTypes = devices => {
  return [...new Set(devices.map(device => device.make))];
};

const events = {
  [HYDRATE_DUMMY]: buildHydrateEvent(dummyData),

  [DEVICES_FETCHED]: (state, { devices }) => ({
    ...state,
    devicesById: mapIncomingDevices(devices),
    deviceTypes: mapIncomingDeviceTypes(devices).sort(),
    devicesLoading: false,
  }),

  [CUSTOMER_DETAILS_FETCHED]: (state, { imei }) => ({
    ...state,
    imei: imei,
  }),

  [DEVICES_FETCHED_ERROR]: state => ({ ...state, devicesLoading: false }),

  [DEVICES_FETCHING]: state => ({ ...state, devicesLoading: true }),
};

export default createReducer(initialState, events);
